<template>
  <div class="md-layout">
    <div class="img-wrap" v-for="(image, index) in images" :key="image.index">
      <img
        @mouseenter="showIcons(index)"
        v-lazy="image.thumb || image.file"
        :style="`height: ${imageHeight}px`"
      />
      <md-tooltip v-if="image.reasonName">
        {{ image.reasonName }}
      </md-tooltip>
      <div class="image-buttons">
        <slot
          name="image-actions"
          :isVisible="currentlyShow === index"
          :image="image"
          :index="index"
        >
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");

import usesAccountInfoMixin from "@/mixins/usesAccountInfo";

export default {
  mixins: [usesAccountInfoMixin],

  data() {
    return {
      hover: false,
      currentlyShow: null,
    };
  },

  props: {
    images: Array,
    imageActions: {
      type: Boolean,
      default: false,
    },
    imageHeight: {
      type: Number,
      default: 128,
    },
    columnSize: {
      type: Number,
      default: 25,
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    showIcons(index) {
      this.hover = true;
      this.currentlyShow = index;
    },
    // Interface Methods
    deleteImage(element, index) {
      this.$emit("delete", element, index);
    },
  },
};
</script>

<style lang="css" scoped>
.img-wrap {
  position: relative;
  margin: 0 2px 30px 0;
  width: 192px;
  height: 108px;
}
.image-buttons {
  position: absolute;
  bottom: 20%;
  right: 20%;
}
.name-text {
  position: absolute;
  top: 0;
  left: 0;
}

.md-button.md-fab,
.md-button.md-just-icon {
  position: absolute;
  z-index: 100;
}

.delete {
  top: 2px;
  right: 2px;
}
.edit {
  top: 32px;
  right: 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/CloseProject/Matrix.vue